import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import shape1 from '../../images/shape/line-shape03.png'
import shape2 from '../../images/shape/line-shape04.png'
import shape3 from '../../images/shape/pattern02.png'
import shape4 from '../../images/shape/monitor-shape.png'
import shape5 from '../../images/shape/blur-shape.png'

const RoadmapSlider = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const roadmapData = [
        {
            quarter: "Q1",
            year: "2018",
            title: "Started as an Odoo ERP specialist",
            content:
                "We began by helping small and mid-sized businesses implement Odoo for core ERP, accounting, and inventory – focusing on clean, practical configurations.",
        },
        {
            quarter: "Q2",
            year: "2019",
            title: "Manufacturing & inventory automation",
            content:
                "We moved deeper into Odoo Manufacturing & Inventory, designing structured flows for production, warehouses, stock movements, and multi-location control.",
        },
        {
            quarter: "Q3",
            year: "2020",
            title: "Magento & Shopify eCommerce integration",
            content:
                "We added Magento and Shopify to our stack, connecting online stores with Odoo so products, orders, stock, and customers stay perfectly in sync.",
        },
        {
            quarter: "Q4",
            year: "2021",
            title: "React-based dashboards & portals",
            content:
                "We started building custom React JS frontends for reporting, partner portals, and admin dashboards on top of Odoo and eCommerce backends.",
        },
        {
            quarter: "Q5",
            year: "2022",
            title: "React Native mobile apps for clients",
            content:
                "We expanded into React Native, delivering mobile apps for sales teams, delivery staff, and end customers, all connected to the same ERP and store data.",
        },
        {
            quarter: "Q6",
            year: "2023",
            title: "Unified ERP + eCommerce + apps stack",
            content:
                "Our focus turned to full-stack solutions – Odoo ERP, Magento/Shopify, React web, and React Native apps working together as one digital ecosystem.",
        },
        {
            quarter: "Q7",
            year: "2024",
            title: "Scaling with long-term partnerships",
            content:
                "Today, we partner with businesses to continuously improve their ERP, eCommerce, and apps, adding automation, performance tuning, and new features over time.",
        },
    ];

    return (
        <section className="roadmap roadmap-pb pt-130 pb-200 pos-rel" style={{ backgroundColor: "#0F55DC" }}>
            <div className="container">
                <div className="sa-tes_top roadmap-top pos-rel mb-85">
                    <div className="sec-title--two">
                        <div
                            className="sub-title sub-title--strock wow fadeInDown"
                            data-wow-duration="600ms"
                        >
                            <img src="assets/img/icon/process-icon.svg" alt="" />
                            Our Journey
                        </div>

                        {/* CHANGED TITLE */}
                        <h2
                            className="title clr-white wow fadeInDown"
                            data-wow-delay="150ms"
                            data-wow-duration="600ms"
                        >
                            Our journey in ERP, eCommerce & apps
                        </h2>
                    </div>
                    <div className="sa-tes_button roadmap-button">
                        <div className="sa-swiper-btn swiper-button-prev" ref={prevRef}>
                            <i className="fal fa-angle-left"></i>
                        </div>
                        <div className="sa-swiper-btn active swiper-button-next" ref={nextRef}>
                            <i className="fal fa-angle-right"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div className="roadmap-slider-container">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    loop={true}
                    spaceBetween={50}
                    speed={400}
                    slidesPerView={3}
                    centeredSlides={true}
                    autoplay={{
                        delay: 6000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        el: ".swiper-pagination",
                        clickable: true,
                    }}
                    navigation={{
                        nextEl: nextRef.current,
                        prevEl: prevRef.current,
                    }}
                    breakpoints={{
                        1600: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        576: {
                            slidesPerView: 1,
                        },
                        0: {
                            slidesPerView: 1,
                        },
                    }}
                    className="raodmap-slider"
                >
                    {roadmapData.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="roadmap-item">
                                <div className="xb-item--top">
                                    <img src={shape1} alt="" />
                                    <span className="xb-item--ques">{item.quarter}</span>
                                    <img src={shape2} alt="" />
                                </div>
                                <div className="xb-item--holder">
                                    <span className="xb-item--year">{item.year}</span>
                                    <h3 className="xb-item--title">{item.title}</h3>
                                    <p className="xb-item--content">{item.content}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Pagination */}
                <div className="swiper-pagination"></div>
            </div>

            <div className="roadmap-shape">
                <div className="shape shape--one"><img src={shape3} alt=""/></div>
                <div className="shape shape--two"><img src={shape4} alt=""/></div>
                <div className="shape shape--three"><img src={shape5} alt=""/></div>
            </div>
        </section>
    );
};

export default RoadmapSlider;

